import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { Col, Label } from "components/bootstrap";
import { OverlayTrigger } from "components/common";
import DocumentationLink from "components/support/DocumentationLink";
import ContentHeadRow from "components/common/ContentHeadRow";
const Container = styled.div`
  display: flex;
  gap: 3px;
  flex-direction: column;
`;
const FlexRow = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    gap: 5px;

    @media (max-width: ${theme.breakpoints.max.md}) {
      flex-wrap: wrap;
    }
  `
);
const LifecycleIndicatorContainer = styled.span(
  ({ theme }) => css`
    cursor: help;
    margin-left: 5px;
    font-size: ${theme.fonts.size.body};
    line-height: 20px;
    vertical-align: text-top;
  `
);
const TopActions = styled.div(
  ({ $hasMultipleChildren }) => css`
    display: flex;
    gap: 10px;
    align-items: ${$hasMultipleChildren ? "center" : "flex-start"};
  `
);
const Actions = styled.div`
  display: flex !important;
  align-items: flex-end;

  .btn-toolbar {
    display: flex;
  }
`;
const Description = styled.p`
  &&&& {
    margin-top: 0;
  }
`;
const LIFECYCLE_TEXTS = {
  experimental: { label: "page_header.experimental", message: "page_header.experimental_message" },
  legacy: { label: "page_header.legacy", message: "page_header.legacy_message" }
};
const LifecycleIndicator = ({
  lifecycle,
  lifecycleMessage
}) => {
  const { t } = useTranslation("common");
  if (lifecycle === void 0) {
    return null;
  }
  const label = t(LIFECYCLE_TEXTS[lifecycle].label);
  const defaultMessage = t(LIFECYCLE_TEXTS[lifecycle].message);
  return /* @__PURE__ */ React.createElement(LifecycleIndicatorContainer, null, /* @__PURE__ */ React.createElement(OverlayTrigger, { placement: "bottom", overlay: lifecycleMessage || defaultMessage }, /* @__PURE__ */ React.createElement(Label, { bsStyle: "primary" }, label)));
};
const PageHeader = ({
  children = [],
  subpage = false,
  title,
  actions = void 0,
  topActions = void 0,
  lifecycle = void 0,
  lifecycleMessage = void 0,
  className = void 0,
  documentationLink = void 0
}) => {
  const topLevelClassNames = subpage ? "" : "content";
  return /* @__PURE__ */ React.createElement(ContentHeadRow, { className: `${className != null ? className : ""} ${topLevelClassNames}` }, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(FlexRow, null, /* @__PURE__ */ React.createElement("h1", null, title, " ", /* @__PURE__ */ React.createElement("small", null, /* @__PURE__ */ React.createElement(LifecycleIndicator, { lifecycle, lifecycleMessage }))), (documentationLink || topActions) && /* @__PURE__ */ React.createElement(TopActions, { $hasMultipleChildren: !!documentationLink && !!topActions }, documentationLink && /* @__PURE__ */ React.createElement(DocumentationLink, { text: documentationLink.title, page: documentationLink.path, displayIcon: true }), topActions)), /* @__PURE__ */ React.createElement(FlexRow, null, children && /* @__PURE__ */ React.createElement(Description, { className: "description no-bm" }, children), actions && /* @__PURE__ */ React.createElement(Actions, null, actions)))));
};
export default PageHeader;
